import React from 'react'

const ToastContext = React.createContext(null)

const toastTypeClass = {
    info:    'bg-bankroll-info text-white',
    success: 'bg-bankroll-success text-white',
    error:   'bg-bankroll-danger text-white',
}

export function ToastProvider({ children }) {
    const [toasts, setToasts] = React.useState([])

    const addToast = React.useCallback((message, type = 'info') => {
        const id = Date.now()
        setToasts(prev => [...prev, { id, message, type }])
        setTimeout(() => setToasts(prev => prev.filter(t => t.id !== id)), 4500)
    }, [])

    const remove = (id) => setToasts(prev => prev.filter(t => t.id !== id))

    return (
        <ToastContext.Provider value={{ addToast }}>
            {children}
            {toasts.length > 0 && (
                <div className="fixed bottom-5 right-5 z-[200] flex flex-col gap-2 pointer-events-none">
                    {toasts.map(t => (
                        <div
                            key={t.id}
                            className={`flex items-center justify-between gap-2 px-4 py-3 rounded-lg text-sm font-semibold shadow-lg max-w-xs pointer-events-auto animate-[toast-in_0.2s_ease] font-karla ${toastTypeClass[t.type] ?? toastTypeClass.info}`}
                        >
                            <span>{t.message}</span>
                            <button
                                className="bg-transparent border-0 text-inherit text-lg cursor-pointer opacity-70 hover:opacity-100 leading-none p-0 ml-2.5"
                                onClick={() => remove(t.id)}
                            >
                                ×
                            </button>
                        </div>
                    ))}
                </div>
            )}
        </ToastContext.Provider>
    )
}

export function useToast() {
    return React.useContext(ToastContext)
}
